import BackgroundImage from 'images/front-page/GenAI-Spotlight-Collection.png';

import _t from 'i18n!nls/front-page';

const getSpotlightCollectionsData = () => {
  return {
    headline: _t('Get started with GenAI'),
    description: _t('Identify, develop, and execute impactful GenAI business strategies.'),
    ctaText: _t('View all GenAI'),
    ctaTarget: '/explore/generative-ai',
    showCtaArrowIcon: true,
    collectionSets: [
      {
        id: 'genai-lohp-spotlight-collections-new',
        filterName: _t('New'),
        collectionModuleId: 'promo-template-preset-collection',
        presetCollectionId: 'X9R9O56lTPG8OB29CDnpvA',
      },
      {
        id: 'genai-lohp-spotlight-collections-beginner',
        filterName: _t('Beginner'),
        collectionModuleId: 'promo-template-preset-collection',
        presetCollectionId: '7PPMXj9_SiKhsLXDKSvXTA',
      },
      {
        id: 'genai-lohp-spotlight-collections-popular',
        filterName: _t('Popular'),
        collectionModuleId: 'promo-template-preset-collection',
        presetCollectionId: '5tyIWPp2S0OFE0hWd1gqow',
      },
      {
        id: 'genai-lohp-spotlight-collections-tools',
        filterName: _t('Tools'),
        collectionModuleId: 'promo-template-preset-collection',
        presetCollectionId: 'H6kMEYk8T_asDn2QMiLTtw',
      },
    ],
    backgroundImage: {
      width: 800,
      url: BackgroundImage,
      description: '',
    },
    layout: 'text2/image10',
  };
};

export default getSpotlightCollectionsData;
